import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Header, Popup, Title } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { updateTaxIdAndShippingDataStatusSelector } from './selectors'
import { resetPopup, updateTaxIdAndShippingAddress } from './slice'

export const TaxInformationCannotValidateModal = () => {
  const dispatch = useDispatch()
  const updateTaxIdAndShippingDataStatus = useSelector(updateTaxIdAndShippingDataStatusSelector)

  const submittingTaxData = () => updateTaxIdAndShippingDataStatus.loading

  return (
    <Popup
      onClose={() => {
        dispatch(resetPopup())
      }}
      size="medium"
      withCloseButton
    >
      <Header>
        <Title>
          {I18n.t('publisher.billing.vat_id_popup.cannot_validate_popup.title')}
        </Title>
      </Header>

      <Body>
        {I18n.t('publisher.billing.vat_id_popup.cannot_validate_popup.body_one')}
        <br />
        <br />
        {I18n.t('publisher.billing.vat_id_popup.cannot_validate_popup.body_two')}
      </Body>

      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={() => dispatch(resetPopup())}
        >
          {I18n.t('publisher.billing.vat_id_popup.cannot_validate_popup.try_again_later')}
        </Button>

        <Button
          onClick={() => dispatch(updateTaxIdAndShippingAddress())}
          loading={submittingTaxData()}
        >
          {I18n.t('publisher.billing.vat_id_popup.cannot_validate_popup.submit')}
        </Button>
      </Footer>
    </Popup>
  )
}
